export function getLanguageDirection(): 'ltr' | 'rtl' {
    if (typeof document !== 'undefined') {
        const html = document.querySelector('html');
        if (html?.getAttribute('dir') === 'rtl') {
            return 'rtl';
        }
    }
    return 'ltr';
}

export function startDirection(): 'right' | 'left' {
    return getLanguageDirection() === 'rtl' ? 'right' : 'left';
}

export function endDirection(): 'right' | 'left' {
    return getLanguageDirection() === 'rtl' ? 'left' : 'right';
}
